export const environment = {
  production: false,
  stage: 'dev',
  graphQLPath: 'https://crm-back.deditec.dev/graphql',
  sentryUrl: 'https://47d68f30904641568428ca1ccba56529@o418080.ingest.sentry.io/5320089',
  whatsappApi: 'https://api.whatsapp.com/send',
  versionName: 'DMSVO.local',
  versionBuild: '',
  dapda360ComponentUrl: 'https://d360-webcomponent-pre.dapda-services.com/dapda360-web-component.js',
  firebase: {
    apiKey: 'AIzaSyBCWPIN9JRIhnoKmd_GRzU6WsoifZ6s7wQ',
    authDomain: 'leadin-develop.firebaseapp.com',
    databaseURL: 'https://leadin-develop.firebaseio.com',
    projectId: 'leadin-develop',
    storageBucket: 'leadin-develop.appspot.com',
    messagingSenderId: '218024908015'
  },
  urlStock: 'https://stock-vo-dashboard.deditec.dev'
};

export const language = {
  defaultLocale: 'es',
  locales: ['en', 'es', 'pt']
};